import PeopleCardRouteIdType from 'mini-people-common/lib/schema/PeopleCardRouteIdType';
import PeopleCardRouteStore from './schema/PeopleCardRouteStore';
import { createStore } from 'satcheljs';

const initialState: PeopleCardRouteStore = {
    currentRoute: {
        routeId: null,
        routeIdType: PeopleCardRouteIdType.None,
        view: null,
    },
    peopleCardMountProps: {
        emailAddress: null,
    },
};

export const getPeopleCardRouteStore = createStore<PeopleCardRouteStore>(
    'PeopleRouteCardStore',
    initialState
);

const PeopleCardRouteStore = getPeopleCardRouteStore();

export default PeopleCardRouteStore;
